import { useTranslation } from 'react-i18next';

export default function Video() {
  const { t } = useTranslation();

  return (
    <section className="py-12 sm:py-20 bg-gradient-to-b from-gray-800 to-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            {t('video_title')}
          </h2>
        </div>

        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
          <iframe
            className="absolute top-0 left-0 w-full h-full rounded-lg shadow-2xl"
            src="https://www.youtube.com/embed/gdD7mwgGzH4"
            title="Equipamentos em Operação"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}